import ExamImage from "../components/ExamImage";
import QuestionLayout from "./QuestionLayout";
import InstructionAudioButton from "./InstructionAudioButton";

export default function TwoColumnImageChoiceWidget({
  config,
  value = {},
  onChange,
  mode = "edit",
  feedback
}) {
  function updateChoice(id, choiceValue) {
    onChange({
      ...value,
      [id]: choiceValue
    });
  }

  function renderRow(row) {
    const selected = value[row.id] || "";
    const fb = feedback?.parts?.[row.id] ?? null;

    return (
      <div
        key={row.id}
        style={{
          display: "grid",
          gridTemplateColumns: "1fr auto",
          alignItems: "center",
          gap: 12
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 7,
            fontSize: 16,
            fontWeight: row.bold ? "bold" : "normal"
          }}
        >
          <span>{row.text}</span>
          {row.audio && (
            <InstructionAudioButton
              src={row.audio}
              label={`Play ${row.text}`}
            />
          )}
        </div>

        <div style={{ display: "flex", gap: 8 }}>
          {(row.choices || []).map((choice) => {
            const isSelected = selected === choice.value;

            return (
              <button
                key={choice.value}
                type="button"
                disabled={mode !== "edit"}
                onClick={() => updateChoice(row.id, choice.value)}
                style={{
                  width: choice.width || config.choiceImageWidth || 54,
                  height: choice.height || config.choiceImageHeight || 44,
                  padding: 4,
                  borderRadius: 6,
                  background: "#fff",
                  cursor: mode === "edit" ? "pointer" : "default",
                  border:
                    mode === "review" && isSelected
                      ? fb?.correct
                        ? "2px solid #2e7d32"
                        : "2px solid #c62828"
                      : isSelected
                      ? "2px solid #1976d2"
                      : "1px solid #aaa"
                }}
              >
                <ExamImage
                  src={choice.image}
                  alt={choice.alt || choice.value}
                  style={{
                    maxWidth: "100%",
                    maxHeight: "100%",
                    objectFit: "contain",
                    display: "block",
                    margin: "0 auto"
                  }}
                />
              </button>
            );
          })}
        </div>
      </div>
    );
  }

  return (
    <QuestionLayout
      number={config.number}
      prompt={config.prompt}
      points={config.points}
      mode={mode}
      feedback={feedback}
    >
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 4px 1fr",
          columnGap: 24,
          alignItems: "start"
        }}
      >
        <div
          style={{
            display: "grid",
            rowGap: 14
          }}
        >
          {(config.leftRows || []).map(renderRow)}
        </div>

        <div
          style={{
            width: 4,
            height: "100%",
            minHeight: 260,
            background: "#000"
          }}
        />

        <div
          style={{
            display: "grid",
            rowGap: 14
          }}
        >
          {(config.rightRows || []).map(renderRow)}
        </div>
      </div>
    </QuestionLayout>
  );
}